<template>
    <v-flex xs12 style="text-align: center">
        <div style="background-color: #DB1918; height: 2px;">&nbsp;</div>
    </v-flex>
</template>

<script>
    export default {
        name: 'RedLine'
    }
</script>

<style>
</style>
